import constants from './constants';

var HEATMAP_COLORAXIS_OPTIONS = {
    stops: []
};

var configureColorAxis = function configureColorAxis(widgetConfig, customConfig) {
    var HeatmapConfig = widgetConfig.HeatmapConfig,
        TreemapConfig = widgetConfig.TreemapConfig;


    if (HeatmapConfig) {
        var colorPaletteLength = HeatmapConfig.ColorPalette.length;
        var difference = 1 / colorPaletteLength;
        var stopValue = 0;
        for (var index = 0; index < colorPaletteLength; index++) {
            stopValue = stopValue + difference;
            HEATMAP_COLORAXIS_OPTIONS.stops[index] = [stopValue, HeatmapConfig.ColorPalette[index]];
        }
        return HEATMAP_COLORAXIS_OPTIONS;
    } else if (TreemapConfig) {
        var TREEMAP_COLORAXIS_OPTIONS = {
            minColor: '#FFF',
            maxColor: TreemapConfig.Color
        };
        return TREEMAP_COLORAXIS_OPTIONS;
    } else return null;
};

export default configureColorAxis;